import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfileComponent } from './profile.component';
import { ProfileResolve } from './profile.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/profile',
        component: ProfileComponent,
        resolve: {
          profileResolve: ProfileResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
